<div class="message-detail-container">
  <!-- Header generated from sp not hardcoded and pulled from db! -->
  <div class="header">
    <h2>{{ notificationInfo.title || ('MESSAGES.DETAIL_TITLE' | translate) }}</h2>
    <p class="notification-body" *ngIf="notificationInfo.body">{{ notificationInfo.body }}</p>
  </div>

  <div class="error" *ngIf="error && !loading()">
    <div class="error-card">
      <h3>{{ 'GLOBAL.ERROR' | translate }}</h3>
      <p>{{ error }}</p>
    </div>
  </div>

  <div *ngIf="!loading() && !error && htmlContent" [innerHTML]="htmlContent"></div>

  <div class="content" *ngIf="!loading() && !error && !htmlContent">
    <div class="sales-card" *ngFor="let sale of salesData; trackBy: trackBySalesItem">

      <div class="sales-header">
        <div class="document-info">
          <h3>{{ 'MESSAGES.DOCUMENT' | translate }} {{ sale.DocumentNumber }}</h3>
          <span class="store-badge">{{ 'MESSAGES.STORE' | translate }} {{ sale.BusinessUnitInternalNumber }}</span>
        </div>
      </div>

      <div class="sales-meta">
        <div class="cashier-info">
          <strong>{{ 'MESSAGES.CASHIER' | translate }}</strong> {{ sale.UserName }}
        </div>
      </div>

      <div class="item-info">
        <div class="item-header">
          <span class="item-code">{{ 'MESSAGES.CODE' | translate }} {{ sale.VirtualItemNumber }}</span>
        </div>
        <div class="item-description">
          {{ sale.Text }}
        </div>
      </div>

      <div class="price-info">
        <div class="price-row">
          <span class="price-label">{{ 'MESSAGES.PRICE' | translate }}</span>
          <span class="price-value">{{ sale.FinalPrice | number:'1.2-2' }} {{ sale.CurrencyIsoCode }}</span>
        </div>
        <div class="discount-row">
          <span class="discount-label">{{ 'MESSAGES.DISCOUNT' | translate }}</span>
          <span class="discount-value">{{ sale.CalculatedValue | number:'1.2-2' }} {{ sale.CurrencyIsoCode }}</span>
        </div>
      </div>
    </div>

    <div class="no-data" *ngIf="salesData.length === 0">
      <p>{{ 'MESSAGES.NODATA' | translate }}</p>
    </div>
  </div>

  <div class="metadata" *ngIf="!loading() && !error && notificationInfo.created">
    <small>{{ 'GLOBAL.CREATED' | translate }} {{ notificationInfo.created | date:'dd.MM.yyyy HH:mm' }}</small>
  </div>

  <div class="loading" *ngIf="loading()">
    <div class="loading-spinner"></div>
    <p>{{ 'MESSAGES.LOADING' | translate }}</p>
  </div>
</div>